import studentBlockedComponent from './blocked.component';


export default angular
  .module('fizyweb.paycell.student.blocked', [])
  .component('blocked', studentBlockedComponent).name;



// WEBPACK FOOTER //
// src/app/components/student/blocked/blocked.module.ts